import { useState, type ReactNode } from 'react';
import TopNav from './TopNav';
import SessionWarning from '../SessionWarning';
import ChatWidget from '../chat/ChatWidget';

export default function AppLayout({ children }: { children: ReactNode }) {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNav onToggleChat={() => setChatOpen((o) => !o)} chatOpen={chatOpen} />
      <SessionWarning />
      <ChatWidget isOpen={chatOpen} onClose={() => setChatOpen(false)} />
      <main className="pt-14">
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
